import type { List } from 'app/generated/graphql'
import { TREATMENT_POPULATION } from 'app/components/action-center/treatmentBands'
import type { TreatmentDestination, TreatmentLane } from 'app/types/treatment'
import { TREATMENT_LIST } from 'lib/systemLists'

export function listTreatmentLanes(list: Pick<List, `stages`>): TreatmentLane[] {
  return (list.stages ?? []).map((stage) => ({ id: stage.id, label: stage.name }))
}

// The dot classes are generated from the stage color tokens in src/styles/tailwind.css (`@source inline`).
export function listTreatmentDestinations(list: Pick<List, `stages`>): TreatmentDestination[] {
  return (list.stages ?? []).map((stage) => ({
    name: stage.name,
    dot: stage.color ? `bg-${stage.color}` : `bg-surface-strong`,
  }))
}

/**
 * The lane a card sits in. The sync can leave a contact with no status, or with Scheduled or Completed
 * before its value catches up, and the board draws no lane for either, so those read as the fallback.
 */
export function treatmentLaneOf(
  status: string | null | undefined,
  lanes: readonly TreatmentLane[],
  fallback: string,
): string {
  return status && lanes.some((lane) => lane.label === status) ? status : fallback
}

const { statusField, bookedStage } = TREATMENT_LIST

/** People with treatment still to book, plus everyone a booking already moved to the booked stage, who owe nothing. */
export const TREATMENT_POPULATION_WITH_BOOKED = `(${TREATMENT_POPULATION} OR ${statusField}.keyword:"${bookedStage}")`

/**
 * The board's value term once the list has its booked stage. Undefined until the stage exists, so the
 * search stays what it was. An OR group with no NOT in it is safe for the search.
 */
export function treatmentPopulation(list: Pick<List, `stages`> | undefined): string | undefined {
  return list?.stages?.some((stage) => stage.name === bookedStage) ? TREATMENT_POPULATION_WITH_BOOKED : undefined
}
